import { React, useState } from "react";
import "./sectionTwo.css";
import character_icon_selected from "../../../images/feature-character-icon-selected.png";
import character_icon_not_selected from "../../../images/feature-character-icon-not-selected.png";
import effect_icon_selected from "../../../images/feature-effect-icon-selected.png";
import effect_icon_not_selected from "../../../images/feature-effect-icon-not-selected.png";
import filter_icon_not_selected from "../../../images/feature-filter-icon-not-selected.png";
import filter_icon_selected from "../../../images/feature-filter-icon-selected.png";

const IconHeader = ({ product, setProduct }) => {
  const getIcons = (product) => {
    if (product === "character") {
      return (
        <>
          <div className="two-header-item item-select">
            <img
              className="two-header-item-image"
              onClick={() => setProduct("character")}
              src={character_icon_selected}
              alt="failed to load"
            />
            <p>Character</p>
          </div>
          <div className="two-header-item">
            <img
              className="two-header-item-image"
              onClick={() => setProduct("effects")}
              src={effect_icon_not_selected}
              alt="failed to load"
            />
            <p>Effects</p>
          </div>
          <div className="two-header-item">
            <img
              className="two-header-item-image"
              onClick={() => setProduct("filter")}
              src={filter_icon_not_selected}
              alt="failed to load"
            />
            <p>Filter</p>
          </div>
        </>
      );
    } else if (product === "effects") {
      return (
        <>
          <div className="two-header-item">
            <img
              className="two-header-item-image"
              onClick={() => setProduct("character")}
              src={character_icon_not_selected}
              alt="failed to load"
            />
            <p>Character</p>
          </div>
          <div className="two-header-item item-select">
            <img
              className="two-header-item-image"
              onClick={() => setProduct("effects")}
              src={effect_icon_selected}
              alt="failed to load"
            />
            <p>Effects</p>
          </div>
          <div className="two-header-item">
            <img
              className="two-header-item-image"
              onClick={() => setProduct("filter")}
              src={filter_icon_not_selected}
              alt="failed to load"
            />
            <p>Filter</p>
          </div>
        </>
      );
    } else if (product === "filter") {
      return (
        <>
          <div className="two-header-item">
            <img
              className="two-header-item-image"
              onClick={() => setProduct("character")}
              src={character_icon_not_selected}
              alt="failed to load"
            />
            <p>Character</p>
          </div>
          <div className="two-header-item">
            <img
              className="two-header-item-image"
              onClick={() => setProduct("effects")}
              src={effect_icon_not_selected}
              alt="failed to load"
            />
            <p>Effects</p>
          </div>
          <div className="two-header-item item-select">
            <img
              className="two-header-item-image"
              onClick={() => setProduct("filter")}
              src={filter_icon_selected}
              alt="failed to load"
            />
            <p>Filter</p>
          </div>
        </>
      );
    }
  };

  return <div className="two-header">{getIcons(product)}</div>;
};

export default IconHeader;
